var diff=(a,b)=>a.filter(a=>0>b.indexOf(a));export default diff;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/axis/utils/array/diff.js
// module id = QXe4
// module chunks = 1